import { ExternalFeatureCategories } from "clearline-api";

export class ExternalFeatureCategoriesTitle {
  id: ExternalFeatureCategories;
  title: string;
}
export const externalFeatureCategoriesTitleSettings: ExternalFeatureCategoriesTitle[] = [
  {
    id: ExternalFeatureCategories.MarketingAppsSettings,
    title: "Marketing Apps Settings"
  },
  {
    id: ExternalFeatureCategories.AdvancedMarketingTools,
    title: "Advanced Tools"
  },
  {
    id: ExternalFeatureCategories.OutboundCampaigns,
    title: "OutboundCampaigns"
  },
  {
    id: ExternalFeatureCategories.ReportingAnalytics,
    title: "ReportingAnalytics"
  },
  {
    id: ExternalFeatureCategories.Contacts,
    title: "Contacts"
  },
  {
    id: ExternalFeatureCategories.CustomTransactionReport,
    title: "CustomTransactionReport"
  },
  {
    id: ExternalFeatureCategories.LoyaltyReporting,
    title: "LoyaltyReporting"
  }
];
